import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/447412843259" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-colors" initial={{
    scale: 0
  }} animate={{
    scale: 1
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} data-id="element-210">
      <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-75" data-id="element-211"></span>
      <MessageCircle className="h-8 w-8 text-white relative z-10" data-id="element-212" />
    </motion.a>;
}